<template>
  <div class="view">
    <div class="content">
      <div class="set_wrap" v-if="settingInfo">
        <el-form label-width="150px">
          <el-form-item label="动态封面:">
            <uploadImg @getChildValue="getChildValue" imgNumber="1" page="moments"
                       :picSrc="settingInfo.dynamic_pic"></uploadImg>
          </el-form-item>
          <el-form-item label="动态简介:">
            <el-input class="w340 whd-textarea" :rows="3" type="textarea" v-model="settingInfo.dynamic_content" maxlength="40" show-word-limit></el-input>  
          </el-form-item>
          <el-form-item label="评论功能:">
            <el-switch v-model="switchStatus" active-color="#2AA3F8" inactive-color="#ddd"></el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
  import api from '@/api.js'
  import uploadImg from "@/components/dialog/uploadImg.vue";

  export default {
    name: "setPannel",
    data() {
      return {
        uploadImg: api.uploadTokenImg,
        data_: {token: sessionStorage.getItem("token")},
        settingInfo: null,
        switchStatus: false
      };
    },
    components: {
      uploadImg
    },
    created() {
      this.InitFn()
    },
    methods: {
      InitFn() {
        this.axios
            .post(api.diaryconf_index, {})
            .then(response => {
              if (response.data.code == 0) {
                // "dynamic_comment":"动态评论功能(0关闭、1开启)",
                let dynamic_comment = false
                if (response.data.info.dynamic_comment === 1) {
                  dynamic_comment = true
                }
                this.switchStatus = dynamic_comment
                this.settingInfo = response.data.info
              } else {
              }
            })
            .catch(response => {
            });
      },
      handleAvatarSuccess(res, file) {
        // this.imageUrl = URL.createObjectURL(file.raw);
        this.settingInfo.dynamic_pic = res.path
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 10MB!");
        }
        return isLt2M;
      },
      onSubmit() {
        if (!this.settingInfo.dynamic_pic) {
          this.$message.error('请上传动态封面图');
          return
        }
        // "dynamic_comment":"动态评论功能(0关闭、1开启)",
        let dynamic_comment = 0
        let data_ = {}
        if (this.switchStatus) {
          dynamic_comment = 1
        }
        data_.dynamic_pic = this.settingInfo.dynamic_pic
        data_.dynamic_content = this.settingInfo.dynamic_content
        data_.dynamic_comment = dynamic_comment
        this.axios
            .post(api.diaryconf_edit, data_)
            .then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '保存成功',
                });
              } else {
              }
            })
            .catch(response => {
            });
      },
      getChildValue(option) {
        this.settingInfo.dynamic_pic = option
      }
    }
  };
</script>
